export default "057c3111f88e6f1a.svg"